

































































































































import { computed, defineComponent } from '@vue/composition-api';

import CommonUnitSelector from '@/components/Delivery/CommonUnitSelector.vue';

const ItemOrder = defineComponent({
  components: { CommonUnitSelector },
  props: {
    index: {
      type: Number,
      default: 0,
    },
    length: {
      type: Number,
      default: 0,
    },
    value: {
      type: Object,
      required: true,
    },
  },
  setup(props, { emit }) {
    const toDecimalFormat = (string: string, digit = 2) => parseFloat(string || '0').toLocaleString('th-TH', { minimumFractionDigits: digit, maximumFractionDigits: digit });
    const computedTotalCount = computed(() => props.value.count * props.value.unitsPerCount);
    const computedDeliveryFee = computed(() => props.value.deliveryFee);

    function deliveryFeeRateInput($event: any) {
      emit('input', { ...props.value, deliveryFee: $event * (props.value.count || 0) });
    }
    function itemCountInput($event: any) {
      emit('input', { ...props.value, deliveryFee: (props.value.deliveryFeeRate || 0) * $event });
    }

    return {
      computedTotalCount,
      computedDeliveryFee,
      toDecimalFormat,
      deliveryFeeRateInput,
      itemCountInput,
    };
  },
});

export default ItemOrder;
